import { CommonModule, DatePipe } from '@angular/common';
import { Component, input } from '@angular/core';

@Component({
  selector: 'app-policy-start-date',
  standalone: true,
  imports: [CommonModule, DatePipe],
  templateUrl: './policy-start-date.component.html',
  styleUrl: './policy-start-date.component.scss',
})
export class PolicyStartDateComponent {
  startDate = input(new Date(new Date().toLocaleString('en-US', { timeZone: 'America/Bogota' })));
  label = input<string>('El seguro de tu arrendamiento inicia el');
}
